// extracted by mini-css-extract-plugin
export default {"alumniWrapper":"Alumni_alumniWrapper__49nRT","alumniGrid":"Alumni_alumniGrid__JPzq9"};